import React from "react";
import Marquee from "react-fast-marquee";

// Giant outlined kinetic text sliding in the background of sections.
const KineticMarquee = ({ text = "GRABARTE", direction = "left", speed = 60, className = "", variant = "stroke" }) => {
  const words = Array.from({ length: 6 }).map((_, i) => (
    <span
      key={i}
      className={`font-display font-black uppercase leading-none ${variant === "stroke" ? "text-stroke" : "text-white/5"}`}
      style={{ fontSize: "clamp(4rem, 14vw, 16rem)", paddingRight: "0.15em", whiteSpace: "nowrap" }}
    >
      {text}
    </span>
  ));
  return (
    <div className={`pointer-events-none select-none overflow-hidden w-full max-w-full ${className}`} aria-hidden="true">
      <Marquee direction={direction} speed={speed} gradient={false} autoFill>
        {words}
      </Marquee>
    </div>
  );
};

export default KineticMarquee;
